"use client"

import { useEffect } from "react"
import { isTestEnvironment } from "@/lib/cbe-debug"
import { isCbeBirrPlusAvailable } from "@/lib/cbe-birr-plus"

export default function VConsoleInit() {
  useEffect(() => {
    if (typeof window === "undefined") return
    const inCbeBirr = isCbeBirrPlusAvailable()
    console.log("[vConsole] init check", { inCbeBirr, testEnv: isTestEnvironment() })
    if (!isTestEnvironment() && !inCbeBirr) return
    if ((window as any).vConsole) return

    import("vconsole")
      .then((VConsole) => {
        if (VConsole?.default) {
          const vConsole = new VConsole.default()
          ;(window as any).vConsole = vConsole
          console.log("[vConsole] enabled", { inCbeBirr, testEnv: isTestEnvironment() })
        }
      })
      .catch((error) => {
        console.warn("[vConsole] Failed to initialize:", error)
      })
  }, [])

  return null
}
